import { render } from "./BaseMoney.vue?vue&type=template&id=f8dc4432"
import script from "./BaseMoney.js?vue&type=script&lang=js"
export * from "./BaseMoney.js?vue&type=script&lang=js"

import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__